
export function getToken() {
  return localStorage.getItem('token')
}

